<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .outcome-view {
    display: flex;
    flex-direction: column;
    padding: 16px;
    background-color: rgba(#1c1c25, 0.75);
    gap: 10px;
    flex: 1;

    .form-fields {
      display: flex;
      flex-direction: column;
      flex: 1;
      gap: 10px;

      .call-notes-textarea {
        flex: 1;
        background-color: #363636;
        color: white;
        border: 1px solid colors.get(interfaceSwGrey_10);
        border-radius: 10px;
        padding: 12px;
        font-family: inherit;
        @include mixins.body2();
        resize: none;
        min-height: 100px;

        &:focus {
          outline: 1px solid colors.get(primary_40);
        }

        &::placeholder {
          color: colors.get(textDisabledGrey);
        }

        &[readonly] {
          opacity: 0.7;
        }
      }
    }
  }

  .outcome-view {
    .buttons {
      display: flex;
      flex-direction: row;
      gap: 6px;
      justify-content: flex-end;
    }
  }
</style>

<script>
  import Button from "../../../../../../svelte-design-system/components/atoms/Button.svelte";
  import SingleSelectDropdown from "../../../../../../svelte-design-system/components/molecules/Dropdown/SingleSelectDropdown/SingleSelectDropdown.svelte";
  import { showToast, ToastError } from "@sourcewhale/core";
  import { diallerLogCallOutcome } from "@sourcewhale/api";
  import { diallerState } from "../diallerState.svelte";
  import { callOutcomesStore } from "../stores";

  let selectedOutcomeId = $state("");
  let callNote = $state("");
  let isSaving = $state(false);

  let outcomeOptions = $derived(
    $callOutcomesStore.map((outcome) => ({
      id: outcome.id,
      label: outcome.name,
    })),
  );

  let canSave = $derived((callNote || selectedOutcomeId) && !isSaving);

  const handleSave = async () => {
    if (!canSave) {
      return;
    }

    isSaving = true;

    try {
      const callSid = diallerState.callId;
      if (!callSid) {
        throw new Error("No call ID available");
      }

      const response = await diallerLogCallOutcome({
        callSid: callSid,
        outcomeId: selectedOutcomeId,
        note: callNote.trim(),
        direction: diallerState.callDirection,
      });

      showToast({
        title: response.message,
        type: "success",
      });

      diallerState.isLogged = true;
      handleCancel();
    } catch (err) {
      if (err instanceof ToastError) {
        err.title = "Failed to log call outcome";
        showToast(err);
      } else {
        showToast({
          title: "Failed to log call outcome",
          subtitle:
            err.message || "An unexpected error occurred. Please try again.",
          type: "danger",
        });
      }
    } finally {
      isSaving = false;
    }
  };

  const handleCancel = () => {
    // If call is still active, just close the outcome modal and return to call view
    if (diallerState.activeCall) {
      diallerState.viewMode = "user";
    } else {
      // If call has ended, close the entire dialler
      diallerState.closeDialler();
    }
  };
</script>

<div class="outcome-view">
  <div class="form-fields">
    <textarea
      class="call-notes-textarea"
      bind:value={callNote}
      placeholder="Call notes"
      readonly={isSaving}
    ></textarea>

    <SingleSelectDropdown
      placeholder="Select an outcome"
      items={outcomeOptions}
      bind:selected={selectedOutcomeId}
      showFilter={false}
      placement="top"
      scrollToSelected={false}
    />
  </div>

  <div class="buttons">
    <Button
      kind="ghost-blue"
      size="large"
      onclick={handleCancel}
      disabled={isSaving}>Cancel</Button
    >
    <Button
      kind="primary"
      size="large"
      class={canSave ? "" : "disabled"}
      onclick={handleSave}
      disabled={!canSave}
      isLoading={isSaving}>Save</Button
    >
  </div>
</div>
